import { FC } from 'react'

import { StandardButton } from 'src/components/atoms'

type Props = {
  className?: string
}

export const OutputReport: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      {/* TODO: レポート出力機能の追加 */}
      <StandardButton
        text="レポート出力"
        buttonType="secondary"
        appendIconPath="download/soft/line"
      />
    </div>
  )
}
